import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { FieldPath, useForm } from 'react-hook-form'
import isEmail from 'validator/lib/isEmail'

import { ButtonStyles } from 'UI/Button/types'
import plusIconSrc from 'UI/Button/images/plus.svg'
import { Button } from 'UI'
import { AsyncThunkActionResponse, ValidationErrorMessages } from 'types'
import { useActions, useAppSelector } from 'hooks/redux'
import { InviteUserParams } from 'API/SchoolService/types'
import { SuccessInviteModal, InviteUserModal } from 'components/Users/modals'
import { schoolQuery, selectsQuery } from 'store/queries'
import MaxUsersModal from '../MaxUsersModal/MaxUsersModal'

const InviteUser = () => {
	const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)
	const [maxUsersModalActive, setMaxUsersModalActive] = useState(false)
	const [isInviteSuccessModalOpen, setIsInviteSuccessModalOpen] =
		useState(false)
	const [email, setEmail] = useState('')

	const { inviteUser } = useActions((state) => state.school)
	const { currentSchoolId } = useAppSelector((s) => s.system)

	const { data: tariffsInfo } = selectsQuery.useGetTariffsQuery()

	const { data: schoolData } =
		schoolQuery.useGetSchoolByIdQuery({
			schoolId: Number(currentSchoolId)
		})

	const maxUsersReached = useMemo(() => {
		if (!tariffsInfo || !schoolData) return undefined
		const currentTariff = tariffsInfo.data.find(
			(t) => t.id.toString() === schoolData.data.rateId.toString()
		)

		const maxUsers = currentTariff?.value.numberUsers
		const currentUsersNumber = schoolData.data.usersIdList.length

		if (maxUsers) {
			return maxUsers <= currentUsersNumber
		}
	}, [tariffsInfo, schoolData])

	const modalInviteCloseHandler = () => {
		setIsInviteModalOpen(false)
	}
	const modalInviteOpenHandler = () => {
		if (maxUsersReached) {
			setMaxUsersModalActive(true)
		} else {
			setIsInviteModalOpen(true)
		}
	}

	const modalInviteSuccessCloseHandler = () => {
		setIsInviteSuccessModalOpen(false)
	}
	const modalInviteSuccessOpenHandler = () => {
		setIsInviteSuccessModalOpen(true)
	}
	const modalIMaxUsersHandler = () => {
		setMaxUsersModalActive(false)
	}

	const {
		register,
		formState: { errors },
		handleSubmit,
		setValue,
		control
	} = useForm<InviteUserParams>()

	useEffect(() => {
		register('email', {
			required: ValidationErrorMessages.EMPTY,
			validate: {
				value: (value) => isEmail(value) || ValidationErrorMessages.INCORRECT
			}
		})
	}, [])

	const changeHandler = useCallback(
		(name: FieldPath<InviteUserParams>) => (value: string) => {
			setValue(name, value)
		},
		[]
	)

	const submitHandler = useCallback(
		handleSubmit(async (data: InviteUserParams) => {
			const response = await inviteUser(data)
			const {
				meta: { requestStatus }
			} = response as unknown as AsyncThunkActionResponse
			if (requestStatus === 'rejected') {
				return
			}
			setEmail(data.email)
			modalInviteCloseHandler()
			modalInviteSuccessOpenHandler()
		}),
		[handleSubmit]
	)
	return (
		<>
			<Button
				onClick={modalInviteOpenHandler}
				styleTypes={[ButtonStyles.PRIMARY, ButtonStyles.ROUND]}
			>
				<img src={plusIconSrc} alt="plus" />
				Добавить пользователя
			</Button>
			<InviteUserModal
				onChange={changeHandler}
				isOpen={isInviteModalOpen}
				errors={errors}
				onClose={modalInviteCloseHandler}
				onSubmit={submitHandler}
				control={control}
			/>
			<SuccessInviteModal
				email={email}
				openInviteModal={modalInviteOpenHandler}
				onClose={modalInviteSuccessCloseHandler}
				isOpen={isInviteSuccessModalOpen}
			/>
			<MaxUsersModal onClose={modalIMaxUsersHandler} isOpen={maxUsersModalActive} />
		</>
	)
}

export default InviteUser
